module.exports = "/_next/static/images/Document-bb7a7b722c4229e0020be0d4dfb25307.webp";